import {useState} from 'react';

const useFilterSelection = () => {
    const [selectedFilters, setSelectedFilters] = useState([]);

    const isFilterSelected = filter => selectedFilters.includes(filter);

    const isNoFilterSelected = () => selectedFilters.length === 0;

    const selectFilter = filter => {
        if (!isFilterSelected(filter)) {
            setSelectedFilters([...selectedFilters, filter]);
        }
    };

    const unselectFilter = filter => {
        if (isFilterSelected(filter)) {
            setSelectedFilters(selectedFilters.filter(selectedFilter => selectedFilter !== filter));
        }
    };

    const toggleFilter = filter => {
        if (isFilterSelected(filter)) {
            unselectFilter(filter);
        } else {
            selectFilter(filter);
        }
    };

    const unselectAllFilters = () => setSelectedFilters([]);

    return {
        selectedFilters,
        isFilterSelected,
        isNoFilterSelected,
        selectFilter,
        unselectFilter,
        toggleFilter,
        unselectAllFilters,
    };
};

export default useFilterSelection;
